import React, {FC, useState} from "react";
import { Input } from "@jane/lib/src/components/form/Input";
import { useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AddTeamSpaceTemplateModal: FC<{onFinish: () => void}> = (props) => {
  const {documentations} = useApiCall(config)
  const [name, setName] = useState('')
  const {showToast} = useToasts()
  const submit = async () => {
    await documentations.addTemplate(name).then(() => {
      showToast('Aangemaakt', 'Sjabloon aangemaakt')
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het aanmaken van het sjabloon')
    })
  }

  return <div className={"flex flex-col space-y-3"}>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <ModalFooter text={'Sjabloon aanmaken'} isDisabled={name.length < 3} onSubmit={async () => {
      await submit()
      close()
      props.onFinish()
    }} />
  </div>
}
